import { Form, Input, Select } from "antd";
import type { FormInstance } from "antd";
import { Customer } from "@lib/types/Customer";
import { customerSchema as yupSchema } from "@lib/schemas/customer";
import { createYupSync } from "@lib/helpers/TableHelper";
import { useIntl } from "react-intl";
import { CountryEnum, CountryCodeEnum } from "@lib/types/Country";
import { convert2label } from "@lib/helpers/StringHelper";
const { TextArea } = Input;

type Props = {
  form: FormInstance<Customer>;
  customer: Customer;
  initialValues: Customer;
};

const CustomerSettings: React.FC<Props> = ({
  form: _form,
  customer: _customer,
  initialValues: _initialValues,
}) => {
  const { messages, formatMessage } = useIntl();

  return (
    <div style={{ padding: "24px" }}>
      <Form.Item
        name="name"
        label={messages["common.customerName"] as string}
        rules={[createYupSync({ schema: yupSchema })]}
      >
        <Input
          placeholder={formatMessage(
            {
              id: "helper.pleaseTypeX",
            },
            { x: messages["common.customerName"] as string },
          )}
          autoComplete="off"
        />
      </Form.Item>
      <Form.Item
        label={(messages["common.email"] as string) || "Email"}
        name="email"
        rules={[createYupSync({ schema: yupSchema })]}
      >
        <Input
          placeholder={formatMessage(
            {
              id: "helper.pleaseTypeX",
            },
            { x: messages["common.email"] as string },
          )}
        />
      </Form.Item>

      <Form.Item
        label={(messages["common.phone"] as string) || "Phone"}
        name="phone"
        rules={[createYupSync({ schema: yupSchema })]}
      >
        <Input
          placeholder={formatMessage(
            {
              id: "helper.pleaseTypeX",
            },
            { x: messages["common.phone"] as string },
          )}
          onChange={(e) => {
            e.target.value = e.target.value.toString();
          }}
        />
      </Form.Item>

      <Form.Item
        label={(messages["common.country"] as string) || "Country"}
        name="country"
        rules={[createYupSync({ schema: yupSchema })]}
      >
        <Select
          allowClear
          showSearch
          optionFilterProp="text"
          options={Object.values(CountryEnum).map((countryCode) => ({
            label: convert2label(CountryCodeEnum[countryCode]),
            text: convert2label(CountryCodeEnum[countryCode]),
            value: countryCode,
          }))}
          placeholder={formatMessage(
            {
              id: "helper.pleaseSelectToX",
            },
            { x: messages["common.country"] as string },
          )}
        />
      </Form.Item>

      <Form.Item
        label={messages["common.city"] as string}
        name="city"
        rules={[createYupSync({ schema: yupSchema })]}
      >
        <Input
          placeholder={formatMessage(
            {
              id: "helper.pleaseTypeX",
            },
            { x: messages["common.city"] as string },
          )}
        />
      </Form.Item>

      <Form.Item
        label={(messages["common.address"] as string) || "Address"}
        name="address"
        rules={[createYupSync({ schema: yupSchema })]}
      >
        <TextArea
          rows={2}
          placeholder={formatMessage(
            {
              id: "helper.pleaseTypeX",
            },
            { x: messages["common.address"] as string },
          )}
        />
      </Form.Item>

      <Form.Item
        label={(messages["common.website"] as string) || "Website"}
        name="website"
        rules={[createYupSync({ schema: yupSchema })]}
      >
        <Input
          placeholder={formatMessage(
            {
              id: "helper.pleaseTypeX",
            },
            { x: messages["common.website"] as string },
          )}
        />
      </Form.Item>

      <Form.Item
        label={(messages["common.taxNumber"] as string) || "Tax Number"}
        name="taxNumber"
        rules={[createYupSync({ schema: yupSchema })]}
      >
        <Input
          placeholder={formatMessage(
            {
              id: "helper.pleaseTypeX",
            },
            { x: messages["common.taxNumber"] as string },
          )}
          onChange={(e) => {
            e.target.value = e.target.value.toString();
          }}
        />
      </Form.Item>
    </div>
  );
};

export default CustomerSettings;
